export default {
  'form': {
    'add-combo': 'Add Combo Service',
    'add-next': 'Save & add next combo',
    'edit-combo': 'Edit Combo',
    'services': 'Services',
    'general': 'General',
    'details': 'Details',
    'pricing-type': 'Pricing',
    'services-required': 'Add at least two services',
    'services-required-2': '(two or more services in combination)',
    'delete': {
      'title': 'Delete combo service?',
      'desc': 'If you delete any of these services, the Combo Service it is part of will also be deleted.',
    },
    'services-tab': {
      'booking-type': 'Booking Type',
      'sequence': 'Sequence',
      'sequence-desc': 'Services are performed one after another. You have the option to add breaks/time between each service.',
      'parallel': 'Parallel',
      'parallel-desc': 'Services are performed at the same time. Each service is assigned to a different Staff Member.',
      'combo': 'Combo',
      'add-service': 'Add service',
      'add-service-to-combo': 'Add Service to Combo',
      'add-break': 'Add time between services',
      'time-between': 'Time between services',
      'service-select-tooltip': 'To create a combo service, you need to select services of the same type.',
    },
    'general-tab': {
      'combo-name': 'Combo name',
      'category': 'Category',
      'book-online': 'Allow clients to book online',
    },
    'pricing-tab': {
      'pricing': 'Pricing type',
      'service-pricing': 'Service Pricing',
      'service-pricing-desc': 'The price for the Combo Service is based on the price for the individual services. If you adjust the price for one of the services, the Combo price will also change.',
      'combo-pricing': 'Custom Pricing',
      'combo-pricing-desc': 'Set a custom price for this Combo Service. It can be higher or lower than the Service Pricing would be, but it won\'t change if you adjust the price for the individual services.',
      'price': 'Price',
      'price-desc': 'Any changes to the price for the individual services will only apply to the Combo Service.',
      'combo-price': 'Combo price',
      'min-length': 'Select the services for this Combo before setting the price',
      'price-display': 'Price · {value}',
    },
    'details-tab': {
      'media': 'Media',
      'combo-description': 'Combo Description',
      'combo-input-placeholder': 'Example: All of your favorite services, combined into one experience.',
    },
  },
}
